<template>
    <div class="wrapper-popup" v-show="showPaymentConfirmation">
        <div class="card-popup">
            <a
                class="button-close"
                @click="showPaymentConfirmation = !showPaymentConfirmation"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="15"
                    viewBox="0 0 384 512"
                >
                    <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                    />
                </svg>
            </a>
            <div class="card-body">
                <h4>
                    Dapatkan tambahan 15 point HCID hanya dengan melakukan
                    pembayaran secara online
                </h4>
                <p>
                    Silahkan klik button Bayar sekarang jika ingin mengubah
                    metode pembayaran menjadi Online
                </p>
                <div class="button">
                    <a @click="close" class="btn white-button mr-auto">Tidak</a>
                    <a @click="updatePayment" class="btn btn-red mr-auto"
                        >Bayar Sekarang</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showPaymentConfirmation: false,
            event: {},
            payment: {}
        };
    },
    methods: {
        openPopup(response) {
            console.log(response);
            this.event = response.event;
            this.payment = response.payment;
            this.showPaymentConfirmation = !this.showPaymentConfirmation;
        },
        close() {
            this.showPaymentConfirmation = !this.showPaymentConfirmation;
            localStorage.setItem("payment-confirmation-popup", "close");
        },
        updatePayment() {
            localStorage.setItem("update-police-number", true);
            localStorage.setItem("change-payment", true);
            window.location.href = `${this.event.tema_seo}/payment?change-payment=true`;
        }
    }
};
</script>
<style lang="scss" scoped>
.wrapper-popup {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(21, 21, 21, 0.8);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;

    .card-popup {
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        padding: 20px;
        width: 90%;
        max-width: 558px;
        height: auto;
        max-height: 90vh;
        overflow-y: auto;

        @media (max-width: 768px) {
        }

        .button-close {
            position: absolute;
            left: auto;
            right: 15px;
        }

        .card-body {
            text-align: center;
            color: rgba(40, 40, 40, 1);
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            p {
                font-size: 15px;
                // width: 400px;
            }

            .button {
                padding-top: 15px;
                position: relative;
                display: flex;
                // width: 100%;
                justify-content: center;
                gap: 10px;
                align-items: center;

                .btn {
                    width: fit-content;
                    max-width: 100%;
                    font-weight: 700;
                    font-size: 14px;
                    padding: 20px;
                    height: 42px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:hover {
                        background-color: #333 !important;
                        color: #fff;
                    }
                }
            }

            .red-button {
                background-color: #e61b33;
                color: #fff;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }

            .white-button {
                background-color: transparent;
                color: #e61b33;
                border: 1px solid #dbdbdb;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }
        }
    }
}

@media (max-width: 768px) {
    .wrapper-popup {
        .card-popup {
            padding: 15px;
            max-width: 90%;
        }
    }
}
</style>
